// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { AppConfig } from "../utils/ConfigTypes";
import AudereConfig from "./Audere";
import CueConfig from "./Cue";
import ExpertReadConfig from "./ExpertRead/";
import HealthPulseConfig from "./HealthPulse/";
import NHSConfig from "./NHS";

/**
 * Use this file to enable/disable features.
 */

const overrides: Partial<AppConfig> = {
  cameraLiveMLRecognitionEnabled: false,
  staticPhotoMLRecognitionEnabled: false,
  cameraOverlayEnabled: false,
  customerConfigs: [
    NHSConfig,
    AudereConfig,
    HealthPulseConfig,
    CueConfig,
    ExpertReadConfig,
  ],
};

export default overrides;
